/* Vitalis Peptides — Catalogo dinamico.
   Interacciones: navbar al hacer scroll, menu movil, y filtros/busqueda/
   orden/cargar-mas sobre las tarjetas de productos REALES que genera el
   liquid. Cada tarjeta lleva a la pagina del producto; el carrito es el
   nativo de Shopify (el boton del header enlaza a /cart). */
(function () {
  'use strict';

  /* Navbar scroll state */
  var navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', function () { navbar.classList.toggle('scrolled', window.scrollY > 16); }, { passive: true });
  }

  /* Mobile menu */
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  var mobileClose = document.getElementById('mobileClose');
  if (hamburger && mobileMenu && mobileClose) {
    var openMenu = function () { mobileMenu.classList.add('open'); document.body.style.overflow = 'hidden'; hamburger.setAttribute('aria-expanded', 'true'); };
    var closeMenu = function () { mobileMenu.classList.remove('open'); document.body.style.overflow = ''; hamburger.setAttribute('aria-expanded', 'false'); };
    hamburger.addEventListener('click', openMenu);
    mobileClose.addEventListener('click', closeMenu);
    document.querySelectorAll('.mobile-menu a').forEach(function (el) { el.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  }

  /* ---------- Catalogo: filtros + busqueda + orden + cargar mas ---------- */
  var grid = document.getElementById('catalogGrid');
  if (!grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.cat-card'));
  var chips = document.querySelectorAll('.chip');
  var searchInput = document.getElementById('searchInput');
  var sortSelect = document.getElementById('sortSelect');
  var resultCount = document.getElementById('resultCount');
  var emptyState = document.getElementById('emptyState');
  var loadMoreWrap = document.getElementById('loadMoreWrap');
  var loadMoreText = document.getElementById('loadMoreText');
  var loadMoreBtn = document.getElementById('loadMoreBtn');

  /* ---------- Selector de presentaciones en cada tarjeta ----------
     Cada .cat-variant lleva data-price, data-img, data-url y data-variant-id.
     Al hacer clic se actualiza el precio, la foto y la variante que agrega
     el botón "Agregar al carrito" de esa tarjeta, sin recargar. */
  cards.forEach(function (card) {
    var variants = card.querySelectorAll('.cat-variant');
    if (variants.length < 2) return;
    var amount = card.querySelector('.cat-price-amount');
    var fromLbl = card.querySelector('.cat-price-from');
    var photo = card.querySelector('.cat-card-photo');
    var cartBtn = card.querySelector('.btn-cart');
    variants.forEach(function (btn) {
      btn.addEventListener('click', function () {
        variants.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (amount && btn.dataset.price) amount.textContent = btn.dataset.price;
        if (fromLbl) fromLbl.style.display = 'none';
        if (photo && btn.dataset.img) photo.src = btn.dataset.img;
        if (cartBtn && btn.dataset.variantId) {
          cartBtn.dataset.variantId = btn.dataset.variantId;
          cartBtn.dataset.soldout = (btn.dataset.available === 'false') ? 'true' : '';
        }
      });
    });
  });

  /* ---------- Selector de cantidad en cada tarjeta ---------- */
  function clampQty(n) { n = parseInt(n, 10); if (isNaN(n) || n < 1) return 1; if (n > 99) return 99; return n; }
  grid.addEventListener('click', function (e) {
    var qb = e.target.closest('.cat-qty-btn');
    if (!qb) return;
    var wrap = qb.closest('.cat-qty');
    var input = wrap ? wrap.querySelector('.cat-qty-input') : null;
    if (!input) return;
    input.value = clampQty(clampQty(input.value) + (qb.dataset.step === '1' ? 1 : -1));
  });
  grid.addEventListener('input', function (e) {
    var input = e.target.closest('.cat-qty-input');
    if (!input) return;
    input.value = input.value.replace(/[^0-9]/g, '');
  });
  grid.addEventListener('blur', function (e) {
    var input = e.target.closest('.cat-qty-input');
    if (!input) return;
    input.value = clampQty(input.value);
  }, true);

  /* ---------- Agregar al carrito desde la tarjeta (carrito real de Shopify) ---------- */
  var cartCountEl = document.getElementById('catCartCount');
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!cartCountEl) return;
        cartCountEl.textContent = c.item_count;
        cartCountEl.classList.toggle('show', c.item_count > 0);
        cartCountEl.classList.remove('bump');
        void cartCountEl.offsetWidth;
        cartCountEl.classList.add('bump');
      }).catch(function () {});
  }
  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('.btn-cart');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var id = btn.dataset.variantId;
    if (!id) return;
    if (btn.dataset.soldout === 'true') {
      var lbl0 = btn.dataset.label || btn.textContent;
      btn.textContent = 'Agotado';
      setTimeout(function () { btn.textContent = lbl0; }, 1500);
      return;
    }
    var qtyInput = btn.closest('.cat-card') ? btn.closest('.cat-card').querySelector('.cat-qty-input') : null;
    var qty = clampQty(qtyInput ? qtyInput.value : 1);
    var original = btn.innerHTML;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add-failed');
      return r.json();
    }).then(function () {
      btn.innerHTML = '¡Agregado! ✓';
      btn.classList.add('added');
      refreshCartCount();
      setTimeout(function () { btn.innerHTML = original; btn.classList.remove('added'); btn.disabled = false; }, 1600);
    }).catch(function () {
      btn.innerHTML = 'Intenta de nuevo';
      setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1600);
    });
  });

  var PAGE = 12;
  var state = { category: 'todos', search: '', sort: 'destacados', limit: PAGE };

  function matches(card) {
    var okSearch = !state.search || card.dataset.name.indexOf(state.search) !== -1;
    /* Si hay busqueda por nombre, ignora el filtro de categoria (busca en TODO el catalogo) */
    if (state.search) return okSearch;
    /* data-category trae TODAS las colecciones del producto separadas por espacio */
    var okCat = state.category === 'todos' || (' ' + card.dataset.category + ' ').indexOf(' ' + state.category + ' ') !== -1;
    return okCat;
  }

  function sortCards(list) {
    var s = state.sort;
    return list.sort(function (a, b) {
      if (s === 'precio-asc') return (+a.dataset.price) - (+b.dataset.price);
      if (s === 'precio-desc') return (+b.dataset.price) - (+a.dataset.price);
      if (s === 'nombre') return a.dataset.name.localeCompare(b.dataset.name);
      return (+a.dataset.order) - (+b.dataset.order);
    });
  }

  function render() {
    var filtered = sortCards(cards.filter(matches));

    // Reordenar en el DOM segun el sort actual
    filtered.forEach(function (c) { grid.appendChild(c); });

    // Mostrar/ocultar segun limite
    cards.forEach(function (c) { c.classList.add('is-hidden'); });
    var shown = filtered.slice(0, state.limit);
    shown.forEach(function (c) { c.classList.remove('is-hidden'); });

    // Conteo
    resultCount.innerHTML = 'Mostrando <strong>' + shown.length + '</strong> de <strong>' + filtered.length + '</strong> productos';

    // Empty state
    emptyState.classList.toggle('show', filtered.length === 0);
    grid.style.display = filtered.length === 0 ? 'none' : '';

    // Cargar mas
    if (filtered.length > state.limit) {
      loadMoreWrap.style.display = '';
      loadMoreText.textContent = 'Mostrando ' + shown.length + ' de ' + filtered.length + ' productos';
    } else {
      loadMoreWrap.style.display = 'none';
    }
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.classList.remove('active'); });
      chip.classList.add('active');
      state.category = chip.dataset.category;
      state.limit = PAGE;
      render();
    });
  });

  var searchTimer;
  searchInput.addEventListener('input', function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      state.search = searchInput.value.trim().toLowerCase();
      state.limit = PAGE;
      render();
    }, 150);
  });

  sortSelect.addEventListener('change', function () { state.sort = sortSelect.value; render(); });
  loadMoreBtn.addEventListener('click', function () { state.limit += PAGE; render(); });

  /* Filtro preseleccionado desde la URL: /pages/catalogo?filtro=<handle-de-coleccion>
     Lo usan las tarjetas de "Áreas de investigación" de la portada. Si el handle
     no coincide con ningun chip, se queda en "Todos". */
  var pre = null;
  try { pre = new URLSearchParams(window.location.search).get('filtro'); } catch (e) {}
  if (pre) {
    chips.forEach(function (c) {
      if (c.dataset.category === pre) {
        chips.forEach(function (o) { o.classList.remove('active'); });
        c.classList.add('active');
        state.category = pre;
      }
    });
  }

  render();
})();
